<script>
import MainMenuView from '../../../shared/views/MainMenuView';
import ListNotificationsView from '../../views/lists/ListNotificationsView';

export default {
  components: {
    'main-menu-view': MainMenuView,
    'list-notifications-view': ListNotificationsView,
  },
  data() {
    return {};
  },
  computed: {},
  methods: {},
};
</script>
<template>
  <div>
    <main-menu-view />
    <!-- Body Start -->
    <list-notifications-view />
    <!-- Body End -->
  </div>
</template>